import { FC } from "react";

import TopNav from "../../components/TopNav/TopNav";
import ContentLayout from "../ContentLayout/ContentLayout";
import { AddNewBrandLayoutLayoutProps } from "./types";


import styles from "./AddNewBrandLayout.module.css";



const AddNewBrandLayout: FC<AddNewBrandLayoutLayoutProps> = ({ children, title, linkBack }) => {
  return (
    <div className={styles["add-new-brand-layout"]}>
      <TopNav title={title} linkBack={linkBack} />
      <ContentLayout className={styles["add-new-brand-layout__content"]}>{children}</ContentLayout>
    </div>
  );
};

export default AddNewBrandLayout;
